import { createContext, useContext } from 'react';

export interface FirstClickedVideoContextValue {
  firstClickedVideoId: string | null;
  setFirstClickedVideoId: (id: string) => void;
}

export const FirstClickedVideoContext = createContext<FirstClickedVideoContextValue>({
  firstClickedVideoId: null,
  setFirstClickedVideoId: (_id: string) => {
    return;
  },
});

export const useFirstClickedVideo = () => useContext(FirstClickedVideoContext);
